'use client';

import {
  useEffect
} from 'react';

import
  ErrorShell
from '@repo/ui/error-shell';

import {
  MARKETING_ZONE_URL
} from '@repo/auth/zone-urls';

export default function AppError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  useEffect(() => {

    console.error('[App error]', error);
  }, [ error ]);

  return (
    <ErrorShell
      logoHref={MARKETING_ZONE_URL}
      heading="Oops"
      headingSize="text-5xl"
      subheading="Something went wrong"
      message="An unexpected error occurred. Please try again or return home."
      primaryAction={{
        onClick: reset,
        label: 'Try again'
      }}
      secondaryAction={{
        href: MARKETING_ZONE_URL,
        label: 'Back to home'
      }}
    />
  );
}
